import React, { useCallback, useEffect, useState } from "react";
import "../css/navbar.css";
// import menuitems from "../api/menuitems";
import { useAuth } from "../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { documentId, onSnapshot, query, where } from "firebase/firestore";
import { roles } from "../firebase.collection";
import { CircularProgress } from "@mui/material";
import menuitemsBis from "../api/menuitemsBis";
import ProfileWidgetMobile from "./ProfileWidgetMobile";
import CloseIcon from "@mui/icons-material/Close"; // Ajoutez cette ligne en haut de votre fichier

export default function MobileNavbar(props) {
  const { currentUser } = useAuth();
  const [activeLink, setActiveLink] = useState(props.linkActive);
  const [userRole, setUserRole] = useState("");
  const [userIdState] = useState(currentUser ? currentUser.uid : "");

  const [loading, setLoading] = useState(true);

  function handleLinkClick(linkId) {
    setActiveLink(linkId === activeLink ? null : linkId);
  }

  const navigate = useNavigate();

  function handleIconClick(item) {
    handleLinkClick(item.id);
    navigate(item.link);
  }

  const queryRole = useCallback(() => {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;

          setUserRole(role);
          setLoading(false);
        } else {
          console.log("Problem loading roles");
        }
      }
    );
  }, [userIdState]);

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
  }, [currentUser, queryRole]);

  return (
    <div className="mobile-navbar-container">
      <div className="navbar-top-group">
        <div className="profile-widget-component">
          <ProfileWidgetMobile userRole={userRole} />
        </div>

        <div className="menu-items-container">
          {loading ? (
            <div className="circular-progress-container">
              <CircularProgress />
              <div className="loading-text">Loading, please wait...</div>
            </div>
          ) : (
            (() => {
              const groupItems = (list) => {
                const groups = [];
                let current = [];
                list.forEach((item) => {
                  current.push(item);
                  if (item.gapAfter) {
                    groups.push(current);
                    current = [];
                  }
                });
                if (current.length) groups.push(current);
                return groups;
              };
              const topItems = menuitemsBis.filter(
                (item) => item.roles.includes(userRole) && !item.isBottomItem
              );
              return groupItems(topItems).map((group, gi) => (
                <div className="menu-group" key={gi}>
                  {group.map((item, index) => (
                    <div className="sidebar-title-v2" key={index}>
                      <div
                        className="icon-menu"
                        onClick={() => handleIconClick(item)}
                      >
                        {item.icon}
                      </div>

                      <Link
                        className={`link-navbar ${
                          item.id === activeLink ? "active" : ""
                        }`}
                        to={item.link}
                        onClick={() => handleLinkClick(item.id)}
                      >
                        <div
                          className={`menu-title-mobile-v2 ${
                            item.id === activeLink ? "active" : ""
                          }`}
                        >
                          {item.name}
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              ));
            })()
          )}
        </div>
      </div>
      <div className="navbar-middle-group">
        <div className="menu-items-container-middle">
          {menuitemsBis
            .filter(
              (item) => item.roles.includes(userRole) && item.isBottomItem
            )
            .map((item, index) => (
              <div className="sidebar-title-v2" key={index}>
                <div
                  className="icon-menu"
                  onClick={() => handleIconClick(item)}
                >
                  {item.icon}
                </div>
                <Link
                  className={`link-navbar ${
                    item.id === activeLink ? "active" : ""
                  }`}
                  to={item.link}
                  onClick={() => handleLinkClick(item.id)}
                >
                  <div
                    className={`menu-title-mobile-v2 ${
                      item.id === activeLink ? "active" : ""
                    }`}
                  >
                    {item.name}
                  </div>
                </Link>
              </div>
            ))}
        </div>
      </div>

      <div
        className="close-icon"
        onClick={() => navigate(-1)}
        style={{
          cursor: "pointer",
          marginLeft: "auto",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <CloseIcon />
      </div>
      <div className="navbar-bottom-group">{/* <InternetCheck /> */}</div>
    </div>
  );
}
